// Strings used across the whole app (buttons, navigation, field names).
import { registerMessages } from '../i18n.svelte';

registerMessages({
  nl: {
    'common.cancel': 'Annuleren',
    'common.confirm': 'Bevestigen',
    'common.save': 'Opslaan',
    'common.saved': 'Opgeslagen',
    'common.delete': 'Verwijderen',
    'common.edit': 'Bewerken',
    'common.close': 'Sluiten',
    'common.back': 'Terug',
    'common.next': 'Volgende',
    'common.add': 'Toevoegen',
    'common.create': 'Aanmaken',
    'common.search': 'Zoeken',
    'common.search_placeholder': 'Zoeken…',
    'common.loading': 'Laden…',
    'common.retry': 'Opnieuw proberen',
    'common.error_generic': 'Er ging iets mis. Probeer het opnieuw.',
    'common.load_failed': 'Gegevens konden niet worden geladen.',
    'common.optional': 'optioneel',
    'common.none': 'Geen',
    'common.today': 'Vandaag',
    'common.yesterday': 'Gisteren',
    'common.export': 'Exporteren',
    'common.duplicate': 'Dupliceren',
    'common.undo': 'Ongedaan maken',
    'common.apply': 'Toepassen',
    'common.clear': 'Wissen',
    'common.clear_filters': 'Filters wissen',
    'common.reset': 'Herstellen',
    'common.done': 'Klaar',
    'common.more': 'Meer',
    'common.actions': 'Acties',
    'common.selected': '{count} geselecteerd',
    'common.type_to_confirm': 'Typ "{text}" om te bevestigen',
    'common.unknown': 'Onbekend',
    'common.no_client': 'Geen klant',
    'common.no_activity': 'Geen activiteit',
    'common.total': 'Totaal',
    'common.per_hour': '/u',

    'field.client': 'Klant',
    'field.activity': 'Activiteit',
    'field.description': 'Omschrijving',
    'field.rate': 'Tarief',
    'field.hours': 'Uren',
    'field.amount': 'Bedrag',
    'field.date': 'Datum',
    'field.start': 'Start',
    'field.end': 'Eind',
    'field.pause': 'Pauze',
    'field.duration': 'Duur',
    'field.status': 'Status',
    'field.billable': 'Factureerbaar',
    'field.name': 'Naam',
    'field.email': 'E-mail',
    'field.phone': 'Telefoon',
    'field.address': 'Adres',

    'nav.dashboard': 'Dashboard',
    'nav.timer': 'Timer',
    'nav.entries': 'Registraties',
    'nav.clients': 'Klanten',
    'nav.reports': 'Rapporten',
    'nav.settings': 'Instellingen',
    'nav.support': 'Hulp & feedback',
    'nav.logout': 'Uitloggen',
    'nav.search': 'Zoeken of springen naar…',
    'nav.collapse': 'Zijbalk inklappen',
    'nav.expand': 'Zijbalk uitklappen',
    'nav.new_entry': 'Nieuwe registratie',
    'nav.new_client': 'Nieuwe klant',
    'nav.menu': 'Menu',
    'nav.profile': 'Profiel',

    'conn.offline': 'Je bent offline. Wijzigingen aan de timer worden bewaard en verstuurd zodra je weer verbinding hebt.',
    'conn.degraded': 'Timepeak is even niet bereikbaar. We proberen het automatisch opnieuw…',
    'conn.back': 'Verbinding hersteld',
    'conn.queued': '{count} timer-acties wachten op verzending',
    'conn.queued.one': '1 timer-actie wacht op verzending'
  },
  en: {
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.save': 'Save',
    'common.saved': 'Saved',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.add': 'Add',
    'common.create': 'Create',
    'common.search': 'Search',
    'common.search_placeholder': 'Search…',
    'common.loading': 'Loading…',
    'common.retry': 'Try again',
    'common.error_generic': 'Something went wrong. Please try again.',
    'common.load_failed': 'Could not load data.',
    'common.optional': 'optional',
    'common.none': 'None',
    'common.today': 'Today',
    'common.yesterday': 'Yesterday',
    'common.export': 'Export',
    'common.duplicate': 'Duplicate',
    'common.undo': 'Undo',
    'common.apply': 'Apply',
    'common.clear': 'Clear',
    'common.clear_filters': 'Clear filters',
    'common.reset': 'Reset',
    'common.done': 'Done',
    'common.more': 'More',
    'common.actions': 'Actions',
    'common.selected': '{count} selected',
    'common.type_to_confirm': 'Type "{text}" to confirm',
    'common.unknown': 'Unknown',
    'common.no_client': 'No client',
    'common.no_activity': 'No activity',
    'common.total': 'Total',
    'common.per_hour': '/h',

    'field.client': 'Client',
    'field.activity': 'Activity',
    'field.description': 'Description',
    'field.rate': 'Rate',
    'field.hours': 'Hours',
    'field.amount': 'Amount',
    'field.date': 'Date',
    'field.start': 'Start',
    'field.end': 'End',
    'field.pause': 'Break',
    'field.duration': 'Duration',
    'field.status': 'Status',
    'field.billable': 'Billable',
    'field.name': 'Name',
    'field.email': 'Email',
    'field.phone': 'Phone',
    'field.address': 'Address',

    'nav.dashboard': 'Dashboard',
    'nav.timer': 'Timer',
    'nav.entries': 'Time entries',
    'nav.clients': 'Clients',
    'nav.reports': 'Reports',
    'nav.settings': 'Settings',
    'nav.support': 'Help & feedback',
    'nav.logout': 'Sign out',
    'nav.search': 'Search or jump to…',
    'nav.collapse': 'Collapse sidebar',
    'nav.expand': 'Expand sidebar',
    'nav.new_entry': 'New entry',
    'nav.new_client': 'New client',
    'nav.menu': 'Menu',
    'nav.profile': 'Profile',

    'conn.offline': 'You are offline. Timer changes are kept and sent as soon as you are back online.',
    'conn.degraded': 'Timepeak cannot be reached right now. Retrying automatically…',
    'conn.back': 'Connection restored',
    'conn.queued': '{count} timer actions waiting to be sent',
    'conn.queued.one': '1 timer action waiting to be sent'
  }
});
